/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAwsKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetAwsKmsKeyRequest = {
  /**
   * The ID of the key to get.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetAwsKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAwsKmsKeySecurity$outboundSchema: z.ZodMiniType<
  GetAwsKmsKeySecurity$Outbound,
  GetAwsKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAwsKmsKeySecurityToJSON(
  getAwsKmsKeySecurity: GetAwsKmsKeySecurity,
): string {
  return JSON.stringify(
    GetAwsKmsKeySecurity$outboundSchema.parse(getAwsKmsKeySecurity),
  );
}

/** @internal */
export type GetAwsKmsKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAwsKmsKeyRequest$outboundSchema: z.ZodMiniType<
  GetAwsKmsKeyRequest$Outbound,
  GetAwsKmsKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getAwsKmsKeyRequestToJSON(
  getAwsKmsKeyRequest: GetAwsKmsKeyRequest,
): string {
  return JSON.stringify(
    GetAwsKmsKeyRequest$outboundSchema.parse(getAwsKmsKeyRequest),
  );
}
